import ReactDOMServer from 'react-dom/server';
import { jsPDF as JSPdf } from 'jspdf';

import { blobToBase64 } from './blobToBase64';

function generatePdf(Component, pdfName = 'mypdf') {
    const doc = new JSPdf('p', 'pt', 'a4', true);

    doc.html(ReactDOMServer.renderToStaticMarkup(Component), {
        callback(pdf) {
            pdf.save(`${pdfName}.pdf`);
        },
    });
}

async function generatePdfBase64(Component) {
    const doc = new JSPdf('p', 'pt', 'a4', true);

    await doc.html(ReactDOMServer.renderToStaticMarkup(Component));

    const blob = await doc.output('blob');

    const base64 = await blobToBase64(blob);

    return base64;
}

export { generatePdf, generatePdfBase64 };
